import request from '@/utils/request'

export function getUserSpaceList() {
  return request({
    url: `/dms/space/user/list`,
    method: 'get',
  })
}

export function getUserDefaultSpace(data) {
  return request({
    url: '/dms/space/user/default',
    method: 'get',
    params: data
  })
}

export function getDashboardMenus() {
  return request({
    url: '/dms/index/dashboard/menus',
    method: 'get',
  })
}

export function saveUserSpace(data) {
  return request({
    url: '/dms/space/user/save',
    method: 'post',
    data
  })
}
export function globalSearch(data) {
  return request({
    url: '/dms/space/search',
    method: 'post',
    data: data
  })
}